module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "heading"
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ALSO BY")]), _vm._v(" "), _c('br'), _vm._v("M"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ASSIMO")]), _vm._v(" C"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ARLOTTO")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('i', [_vm._v("The Goodbye Kiss")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('i', [_vm._v("Death’s Dark Abyss")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('i', [_vm._v("The Fugitive")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('i', [_vm._v("Poisonville")]), _vm._v(" (with Marco Videtta)")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('i', [_vm._v("Bandit Love")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-315da45a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/Section0002.vue
// module id = 60
// module chunks = 0